import { cls, useWaitedAction } from "reactutils"

export type ButtonProps = {
  type: "primary" | "secondary" | "tertiary" | "text"
  inline?: boolean
  text: string
  onClick?: any
  disabled?: boolean
  className?: string
  style?: string | any
}

export default function Button({
  type,
  inline = false,
  text,
  onClick,
  disabled = false,
  className,
  style,
}: ButtonProps) {
  const { action, duringAction } = useWaitedAction(onClick)

  return (
    <>
      <button
        className={cls("btn", type, inline && "inline", className)}
        style={style}
        onClick={action}
        disabled={disabled || duringAction}
      >
        {text}
      </button>
      <style jsx>{`
        .btn {
          display: flex;
          flex-flow: row nowrap;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 44px;
          font-size: 16px;
          padding: 0 20px;
        }

        .primary {
          border: 0;
          background-color: var(--primaryColor);
          border-radius: 26px;
          font-weight: bold;
          color: #fff;
        }

        .primary:active {
          background: var(--primaryColor);
        }

        .primary:disabled {
          opacity: 0.3;
        }

        .secondary {
          background: #fff;
          border: 1px solid var(--primaryColor);
          border-radius: 26px;
          font-weight: bold;
          color: var(--primaryColor);
        }

        .secondary:active {
          background: rgba(31, 82, 249, 0.08);
        }

        .secondary:disabled {
          opacity: 0.3;
        }

        .tertiary {
          background: #fff;
          border: 1px solid #e5e5e5;
          border-radius: 26px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);
        }

        .tertiary:active {
          background: rgba(0, 0, 0, 0.03);
        }

        .tertiary:disabled {
          color: rgba(0, 0, 0, 0.25);
        }

        .text {
          border: 0;
          background: transparent;
          color: #0547e1;
        }

        .text:active {
          color: #0c3bd6;
        }

        .text:disabled {
          color: rgba(31, 82, 249, 0.25);
        }

        .inline {
          display: inline-flex;
          width: auto;
          padding: 0 26px;
        }
      `}</style>
    </>
  )
}
